module.exports = __webpack_public_path__ + "media/site_templates/www.localbathroomrenovations.net.au/images/splash-b3215d518534d47b6ec78d6c20c35fa8.jpeg";